var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74487 2.73556C10.2732 1.86598 11.5458 1.86598 12.0741 2.73556L13.8936 5.73045C14.0834 6.04285 14.393 6.26565 14.7516 6.34791L18.1892 7.13658C19.1874 7.36557 19.5806 8.56456 18.909 9.33098L16.5959 11.9706C16.3546 12.2459 16.2363 12.6064 16.2682 12.9697L16.5733 16.452C16.6618 17.4631 15.6322 18.2041 14.6888 17.8082L11.4397 16.4447C11.1008 16.3025 10.7182 16.3025 10.3793 16.4447L7.13017 17.8082C6.18679 18.2041 5.15717 17.4631 5.24576 16.452L5.55085 12.9697C5.58268 12.6064 5.46443 12.2459 5.22315 11.9706L2.91 9.33098C2.23838 8.56456 2.63166 7.36557 3.62979 7.13658L7.06744 6.34791C7.42602 6.26565 7.73559 6.04285 7.92538 5.73045L9.74487 2.73556Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dfdc2f5833b4adca1bef087076cd5fe3.svg";
export { ForwardRef as ReactComponent };